type AnyObject = Record<string, unknown>

export function isObject(x: unknown): x is AnyObject {
  return x !== undefined && x !== null && typeof x === 'object'
}
